import request from '@/utils/request'
import axios from 'axios'
import {
  getToken
} from '@/utils/auth'

const BaseUrl = '/bizContract'
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: true,
  timeout: 30000
})

// 保存合同
export function addContract(data) {
  return request({
    url: BaseUrl,
    method: 'post',
    data
  })
}

// 通过id删除合同
export function deleteContractById(id) {
  return request({
    url: `${BaseUrl}/${id}`,
    method: 'delete',
  })
}

// 合同转正
export function updateContractType(id, params) {
  return request({
    url: `${BaseUrl}/updateContractType/${id}`,
    method: 'post',
    params
  })
}

// 通过id获取单个合同
export function findContractById(id) {
  return request({
    url: `${BaseUrl}/${id}`,
    method: 'get',
  })
}

export function getContractList(params) {
  return request({
    url: `${BaseUrl}/list`,
    method: 'get',
    params
  })
}

// 修改合同
export function modifyContract(data) {
  return request({
    url: BaseUrl,
    method: 'put',
    data
  })
}

// 合同变更
export function changeContract(data) {
  return request({
    url: `${BaseUrl}/changeContract`,
    method: 'post',
    data
  })
}

// 删除合同明细
export function removeContractDetails(id) {
  return request({
    url: `${BaseUrl}/deleteBizContractDelivery/${id}`,
    method: 'delete',
  })
}

// 删除付款明细
export function removePaymentDetails(id) {
  return request({
    url: `${BaseUrl}/deleteBizPaymentDetails/${id}`,
    method: 'delete',
  })
}

// 删除资源计划
export function removeResourcePlan(id) {
  return request({
    url: `${BaseUrl}/deleteBizResourcePlanning/${id}`,
    method: 'delete',
  })
}

// 删除时间计划
export function removeTimePlan(id) {
  return request({
    url: `${BaseUrl}/deleteBizTimePlan/${id}`,
    method: 'delete',
  })
}

// 审核或者交付
export function reviewContract(data) {
  return request({
    url: `${BaseUrl}/review`,
    method: 'post',
    data
  })
}
// 文件查询
export function fileShow(id) {
  return request({
    url: `/attachment/masterdata/fileShow/${id}`,
    method: 'get',
  })
}
// 文件删除
export function delFile(id) {
  return request({
    url: `/attachment/${id}`,
    method: 'delete',
  })
}
// 文件下载
// export function downLoad(params) {
//   return request({
//     url: `/attachment/masterdata/fileDownload/`,
//     method: 'get',
//     params
//   })
// }
export function downLoad(id, fileName) {
  service({
    method: 'get',
    url: '/attachment/masterdata/fileDownload/',
    params: {
      id
    },
    responseType: 'arraybuffer',
    headers: {
      Authorization: `Bearer ${getToken()}`,
      filename: 'utf-8'
    }
  }).then(res => {
    // const fileStr = res.headers['content-disposition']
    // const fileName = decodeURI(fileStr.substr(fileStr.indexOf('filename=') + 9))
    // const fileName = new Date().getTime() + '.png'
    const url = window.URL.createObjectURL(new Blob([res.data]))
    const link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    document.body.appendChild(link)
    link.setAttribute('download', fileName)
    link.target = '_blank'
    link.click()
    document.body.removeChild(link); // 下载完成移除元素
    window.URL.revokeObjectURL(url); // 释放掉blob对象
  }).catch(error => {
    console.log(error)
  })
}
// 立项导出
export function downloadExcel(id, label, date) {
  service({
    method: 'get',
    url: `/projectDelivery/export/` + id,
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${getToken()}`,
      filename: 'utf-8',
    },
  }).then(res => {
    const fileName = `${label}.xls`
    const url = window.URL.createObjectURL(res.data)
    const link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    document.body.appendChild(link)
    link.setAttribute('download', fileName)
    link.target = '_blank'
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  }).catch(error => {
    console.log(error)
  })
}
// 批量导出立项excel
export function exportProjectList(id) {
  service({
    method: 'GET',
    url: '/projectDelivery/exportProjectList',
    params: {
      id: id
    },
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    responseType: 'blob'
  }).then(response => {
    const blob = new Blob([response.data], {
      type: 'application/zip'
    })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a') // 创建a标签
    const filename = response.headers['content-disposition'].split(";")[1].split("filename=")[1] + "立项导出";
    link.href = url
    link.download = filename // 重命名文件
    link.click()
    console.log(response)
    URL.revokeObjectURL(url) // 释放内存
  }).catch(error => {
    console.log(error)
  })
}

export function exportListDataExcel(that) {
  service({
    method: 'post',
    url: '/projectDelivery/exportDataList',
    //   params: {
    //     startTime: startTime,
    //     endTime: endTime
    //   },
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    responseType: 'blob'
  }).then(response => {
    const fileName = `项目立项导出.xlsx`
    const blob = new Blob([response.data], {
      type: 'application/vnd.ms-excel'
    })
    const downloadElement = document.createElement('a')
    const href = window.URL.createObjectURL(blob)
    downloadElement.href = href
    downloadElement.download = fileName
    document.body.appendChild(downloadElement)
    downloadElement.click()
    document.body.removeChild(downloadElement) // 下载完成移除元素
    window.URL.revokeObjectURL(href) // 释放掉blob对象
    that.downloadLoading.close();
  }).catch(error => {
    console.log(error)
  })
}

// 生成应收单
export function generateReceivables(data) {
  return request({
    url: `/bizContract/generateReceivables`,
    method: 'post',
    data
  })
}
// 更新应收日期
export function updateReceivablesDate(data) {
  return request({
    url: `/bizContract/updateReceivablesDate`,
    method: 'post',
    data
  })
}
